/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import AppContext from "../Utils/appContext";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import ProductCacheContext from "../Utils/productCacheContext";
import useScrollRestoration from "../Hooks/useScrollRestoration";
import { saveScrollPosition } from "../Utils/scrollPositionManager";
import { extractIdFromGid } from "../Utils/categories-divide";
import { getProductsByCategoryId } from "../Utils/api-service";
import ProductAutoScroll from "./ProductAutoScroll";
import { vibrate } from "../Utils/util-service";

const SubCategoryGridLevel3 = React.memo(() => {
  useScrollRestoration();
  const navigate = useNavigate();
  const location = useLocation();
  const { clearProductCache } = React.useContext(ProductCacheContext);
  let [searchParams] = useSearchParams();
  const [subCats, setSubCats] = React.useState([]);
  const [mainCatgeory, setMainCategory] = React.useState("");
  const [mainCatgeoryID, setMainCategoryID] = React.useState("");
  const [featuredProducts, setFeaturedProducts] = React.useState([]);

  const { subCategories, level3Categories, showPrice } =
    React.useContext(AppContext);
  const categoryID = searchParams.get("categoryID");
  const subCategoryID = searchParams.get("subCategoryID");

  React.useEffect(() => {
    clearProductCache();
  }, []);

  React.useEffect(() => {
    const subCollections = [];
    const filterArr = [];
    level3Categories.forEach((collection) => {
      if (collection.parentMainId === categoryID) {
        subCollections.push(collection);
        if (
          collection?.description &&
          !filterArr.includes(collection.description)
        ) {
          filterArr.push(collection.description);
        }
      }
    });
    setSubCats(subCollections);
    setMainCategory(subCollections[0]?.parentTitle);
    setMainCategoryID(subCollections[0]?.rootMainId);
  }, [subCategories, level3Categories, categoryID]);

  React.useEffect(() => {
    if (!subCategoryID) return;

    let cancelled = false;
    setFeaturedProducts([]);

    getProductsByCategoryId(categoryID)
      .then((data) => {
        if (cancelled) return;
        if (data?.status === 200) {
          setFeaturedProducts(data?.data?.collection?.products?.nodes || []);
        }
      })
      .catch((error) => {
        console.error("Error fetching featured products:", error);
      });

    return () => {
      cancelled = true;
    };
  }, [subCategoryID]);

  const goToProduct = (id) => {
    const productId = extractIdFromGid(id);
    vibrate(20);
    navigate("/product?productId=" + productId);
  };

  return (
    <>
      <section className="pt-2 tab-section">
        <div id="estimate-header">
          <div className="back-links">
            <a
              onClick={() =>
                navigate("/sub-category?categoryID=" + mainCatgeoryID)
              }
            >
              <i className="iconly-Arrow-Left icli"></i>
            </a>
          </div>
          <div className="content">
            <h2>{mainCatgeory}</h2>
          </div>
        </div>
        {featuredProducts.length > 0 && (
          <section className="deals-section px-15 pt-0 pb-2">
            <div className="title-part">
              <h2>Featured Products</h2>
            </div>
            <ProductAutoScroll
              products={featuredProducts}
              showPrice={showPrice}
              onProductClick={goToProduct}
              badgeFallback={<></>}
              showWishlist
              wishlistSource="RECOMMENDED"
            />
            <div className="divider"></div>
          </section>
        )}
        <div className="tab-section">
          {/* <ul className="nav nav-tabs theme-tab pl-15">
            <li className="nav-item">
              <button
                className="nav-link active"
                data-bs-toggle="tab"
                data-bs-target="#trending"
                type="button"
                onClick={() => allCategory()}
              >
                All
              </button>
            </li>
            {filters.map((val, index) => {
              return (
                <li key={index} className="nav-item">
                  <button
                    className="nav-link"
                    data-bs-toggle="tab"
                    data-bs-target="#top"
                    type="button"
                    onClick={() => filterCategory(val)}
                  >
                    {val}
                  </button>
                </li>
              );
            })}
          </ul> */}
          <div className="tab-content px-15">
            <div className="tab-pane fade show active">
              <div className="row gy-3 gx-3">
                {subCats.map((val, idx) => (
                  <div key={idx} className="col-md-4 col-6">
                    <div
                      onClick={() => {
                        saveScrollPosition(location.pathname);
                        navigate(
                          "/product-list?categoryName=" +
                            val?.subTitle +
                            "&categoryId=" +
                            val?.mainId,
                        );
                      }}
                      className="product-box ratio_square"
                    >
                      <div className="img-part">
                        <a>
                          <img
                            src={
                              val?.image?.url || "assets/images/products/4.jpg"
                            }
                            alt=""
                            className="img-fluid bg-img"
                          />
                        </a>
                      </div>
                      <div className="product-content">
                        <a>
                          <h4>{val.subTitle}</h4>
                        </a>
                        {/* <div className="price">
                          <h4>subtitle</h4>
                        </div> */}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
});

export default SubCategoryGridLevel3;
